import { AlertTriangle } from 'lucide-react';
import { CopyButton } from './copy';

/**
 * Shows a value that Tab Service only returns once, with a warning that it
 * cannot be read again.
 */
export function SecretOnce({ label, value, note }: { label: string; value: string; note?: string }) {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-start gap-2 rounded-lg border border-[color:var(--ts-pill-warning-border)] bg-[color:var(--ts-pill-warning-bg)] px-3 py-2.5">
        <AlertTriangle
          className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--ts-pill-warning-text)]"
          aria-hidden="true"
        />
        <p className="text-base text-gray-3">
          Copy this now. {label} is shown once and cannot be retrieved. If it is lost, create a new one.
        </p>
      </div>
      <div className="flex items-center justify-between gap-2 rounded-lg border border-[color:var(--ts-border-soft)] bg-blue-bglayout px-3 py-2.5">
        <code className="min-w-0 flex-1 font-mono text-sm break-all text-gray-3">{value}</code>
        <CopyButton value={value} label={label} />
      </div>
      {note ? <p className="text-sm text-muted-foreground">{note}</p> : null}
    </div>
  );
}
